import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./AddPurchase.css";

const AddStaffAttendance = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    department: "",
    date: "",
    time: "",
    action: "Check-in",
    latitude: "",
    longitude: "",
  });

  const [errors, setErrors] = useState({});
  const [locLoading, setLocLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const e = {};
    if (!formData.name.trim()) e.name = "Name is required";
    if (!formData.designation.trim()) e.designation = "Designation is required";
    if (!formData.department.trim()) e.department = "Department is required";
    if (!formData.date) e.date = "Date is required";
    if (!formData.time) e.time = "Time is required";
    if (!formData.latitude || !formData.longitude) e.location = "Latitude and longitude required";
    return e;
  };

  const handleSubmit = (ev) => {
    ev.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length) {
      setErrors(newErrors);
      return;
    }

    setErrors({});
    const map = `https://maps.google.com/?q=${formData.latitude},${formData.longitude}`;
    const newEntry = { id: Date.now(), ...formData, map };
    console.log("New Attendance Entry:", newEntry);
    navigate("/staffattendance");
  };

  const fillCurrentLocation = () => {
    if (!navigator.geolocation) {
      setErrors({ ...errors, location: "Geolocation not supported by browser" });
      return;
    }
    setLocLoading(true);
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = pos.coords.latitude.toFixed(6);
        const lng = pos.coords.longitude.toFixed(6);
        setFormData((prev) => ({ ...prev, latitude: lat, longitude: lng }));
        setErrors((prev) => {
          const copy = { ...prev };
          delete copy.location;
          return copy;
        });
        setLocLoading(false);
      },
      (err) => {
        setErrors({ ...errors, location: "Unable to fetch location" });
        setLocLoading(false);
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  const renderError = (field) =>
    errors[field] ? <div className="text-danger small mt-1">{errors[field]}</div> : null;

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="mb-0">Add Staff Attendance</h4>
        <button className="btn-top" onClick={() => navigate(-1)}>Back</button>
      </div>

      <form onSubmit={handleSubmit} noValidate>
        <div className="row g-3">
          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleChange}
            />
            {renderError("name")}
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Designation</label>
            <input
              type="text"
              className="form-control"
              name="designation"
              value={formData.designation}
              onChange={handleChange}
            />
            {renderError("designation")}
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Department</label>
            <input
              type="text"
              className="form-control"
              name="department"
              value={formData.department}
              onChange={handleChange}
            />
            {renderError("department")}
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Date</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={formData.date}
              onChange={handleChange}
            />
            {renderError("date")}
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Time</label>
            <input
              type="time"
              className="form-control"
              name="time"
              value={formData.time}
              onChange={handleChange}
            />
            {renderError("time")}
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Action</label>
            <select
              className="form-control custom-select-arrow"
              name="action"
              value={formData.action}
              onChange={handleChange}
            >
              <option value="Check-in">Check-in</option>
              <option value="Check-out">Check-out</option>
            </select>
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Latitude</label>
            <input
              type="number"
              step="any"
              className="form-control"
              name="latitude"
              value={formData.latitude}
              onChange={handleChange}
            />
          </div>

          <div className="col-lg-4 col-md-6 col-sm-12">
            <label className="form-label">Longitude</label>
            <input
              type="number"
              step="any"
              className="form-control"
              name="longitude"
              value={formData.longitude}
              onChange={handleChange}
            />
          </div>

          <div className="col-12">
            <div className="d-flex gap-2 align-items-center">
              <button type="button" className="btn btn-outline-secondary" onClick={fillCurrentLocation} disabled={locLoading}>
                {locLoading ? "Fetching location..." : "Get my location"}
              </button>
              {errors.location && <div className="text-danger small">{errors.location}</div>}
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-end mt-4 gap-2">
          <button type="submit" className="btn-submit">Submit</button>
          <button type="button" className="btn-cancel" onClick={() => navigate(-1)}>Cancel</button>
        </div>
      </form>
    </div>
  );
};

export default AddStaffAttendance;
